const ID_TOKEN_KEY_PROMO = 'tpsre.promo'

export const getPromo = () => {
  return JSON.parse(window.localStorage.getItem(ID_TOKEN_KEY_PROMO))
}

export const setPromo = action => {
  window.localStorage.setItem(ID_TOKEN_KEY_PROMO, JSON.stringify(action))
}

export const removePromo = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY_PROMO)
}

export default {setPromo, getPromo, removePromo}



// WEBPACK FOOTER //
// ./src/common/promo.service.js